import axios from "axios";
import React, { useCallback, useEffect, useMemo, useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Paper,
  Tabs,
  Tab,
  Box,
} from "@material-ui/core";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { dateFormatter } from "../fomatters/DateFormatter";

function Changes({
  className = "",
  classNameButton = "",
  title,
  buttonText,
  hidden,
  customButton,
  params: { ChangeType, IdSport, Param1, Param2, Param3 },
}) {
  const userInfo = useMemo(
    () => JSON.parse(localStorage.getItem("userInfo")),
    []
  );
  const [changes, setChanges] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [fieldChanges, setFieldChanges] = useState([]);

  const [open, setOpen] = useState(false);
  const handleOpenDialog = useCallback((state) => {
    setOpen(state);
  }, []);

  const changesPayload = useMemo(
    () => ({
      ChangeType,
      IdSport,
      Param1,
      Param2,
      Param3,
    }),
    [ChangeType, IdSport, Param1, Param2, Param3]
  );

  /**
   * GET FIELDS
   */
  const requestFieldChanges = useCallback(() => {
    const url = `${process.env.REACT_APP_API2_URL}/Addons/LastChanges_GetFieldChanges`;
    console.log("changesPayload====>", changesPayload);
    axios
      .post(url, {
        FieldName: selectedRow,
        ...changesPayload,
      })
      .then((response) => response.data)
      .then((data) => {
        setFieldChanges(data);
      });
  }, [changesPayload, selectedRow]);

  /**
   * GET CHANGES
   */
  const requestChanges = useCallback(() => {
    const url = `${process.env.REACT_APP_API2_URL}/Addons/LastChanges_GetChanges`;
    console.log("changesPayload2====>", changesPayload);
    axios
      .post(url, changesPayload)
      .then((response) => response.data)
      .then((data) => {
        setChanges(data);
        if (data) {
          const row = data?.[0];
          setSelectedRow(row.fieldName ?? row.FieldName);
        }
      });
  }, [changesPayload]);

  /**
   * TABLE OPTIONS
   */
  const options = {
    sizePerPage: 1000,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
  };

  const handleRowClick = useCallback((row) => {
    setSelectedRow(row.fieldName ?? row.FieldName);
    setTimeout(()=>{
      setTabIndex(1);
    }, 500)
  }, []);

  /**
   * Initial load
   */
  useEffect(() => {
    setTabIndex(0);
    if (open) {
      requestChanges();
    }
  }, [requestChanges, open]);

  useEffect(() => {
    requestFieldChanges();
  }, [requestFieldChanges]);

  const selectRow = useMemo(
    () => ({
      mode: "radio", // 'checkbox' for multiple selection, 'radio' for single selection
      clickToSelect: true,
      selected: [selectedRow],
      onSelect: handleRowClick,
    }),
    [selectedRow, handleRowClick]
  );

  function TabPanel({ children, value, index, ...other }) {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`changes-tabpanel-${index}`}
        aria-labelledby={`changes-tab-${index}`}
        {...other}
      >
        {value === index && <Box mt={2}>{children}</Box>}
      </div>
    );
  }

  const [tabIndex, setTabIndex] = useState(0);
  const handleTabChange = useCallback((_, newIndex) => setTabIndex(newIndex), []);

  return (
    <>
      {customButton ? (
        <div
          className="flex items-center justify-center gap-1 cursor-pointer"
          onClick={() => handleOpenDialog(true)}
        >
          {customButton}
        </div>
      ) : (
        <Button
          hidden={hidden}
          className={`${classNameButton}`}
          variant="contained"
          onClick={() => handleOpenDialog(true)}
        >
          {buttonText ? buttonText : "Last Changes"}
        </Button>
      )}
      <Dialog open={open} fullWidth>
        <DialogContent>
          <div
            id="main-div"
            className={`${className} !h-max w-full flex-grow-0`}
          >
            <Paper>
  <h2>{title}</h2>

  {/* Tabs header */}
  <Tabs
    value={tabIndex}
    onChange={handleTabChange}
    indicatorColor="primary"
    textColor="primary"
    variant="fullWidth"
    aria-label="Last Changes Tabs"
  >
    <Tab label="Last Changes" id="changes-tab-0" aria-controls="changes-tabpanel-0" />
    <Tab label="Field Changes" id="changes-tab-1" aria-controls="changes-tabpanel-1" />
  </Tabs>

  {/* Tab 0: Last Changes */}
  <TabPanel value={tabIndex} index={0}>
    <div className="grid grid-cols-1 gap-2">
      <div className="sticky top-2 h-fit">
        <h3>Last Changes</h3>
        <BootstrapTable
          data={changes}
          options={options}
          pagination
          version="4"
          hover
          selectRow={selectRow}
        >
          <TableHeaderColumn
            isKey
            dataField="fieldName"
            dataSort
            filter={{ type: "TextFilter", delay: 100 }}
            width="250"
          >
            Field Name
          </TableHeaderColumn>
          <TableHeaderColumn dataField="oldValue" dataSort filter={{ type: "TextFilter", delay: 100 }}>
            Old Value
          </TableHeaderColumn>
          <TableHeaderColumn dataField="newValue" dataSort filter={{ type: "TextFilter", delay: 100 }}>
            New Value
          </TableHeaderColumn>
          <TableHeaderColumn dataField="loginName" dataSort filter={{ type: "TextFilter", delay: 100 }}>
            Modified by
          </TableHeaderColumn>
          <TableHeaderColumn dataField="placedDate" dataSort dataFormat={dateFormatter}>
            Last Modified
          </TableHeaderColumn>
          <TableHeaderColumn dataField="phoneLine" dataSort filter={{ type: "TextFilter", delay: 100 }}>
            Phone
          </TableHeaderColumn>
          <TableHeaderColumn dataField="ip" dataSort filter={{ type: "TextFilter", delay: 100 }}>
            IP
          </TableHeaderColumn>
        </BootstrapTable>
      </div>
    </div>
  </TabPanel>

  {/* Tab 1: Field Changes */}
  <TabPanel value={tabIndex} index={1}>
    <div className="grid grid-cols-1 gap-2">
      <div className="sticky top-2 h-fit">
        <h3>Field Changes</h3>
        <BootstrapTable
          data={fieldChanges}
          options={options}
          pagination
          version="4"
          hover
        >
          <TableHeaderColumn hidden isKey dataField="fieldName" dataSort filter={{ type: "TextFilter", delay: 100 }} width="250">
            Field Name
          </TableHeaderColumn>
          <TableHeaderColumn dataField="oldValue" dataSort filter={{ type: "TextFilter", delay: 100 }}>
            Old Value
          </TableHeaderColumn>
          <TableHeaderColumn dataField="newValue" dataSort filter={{ type: "TextFilter", delay: 100 }}>
            New Value
          </TableHeaderColumn>
          <TableHeaderColumn dataField="loginName" dataSort filter={{ type: "TextFilter", delay: 100 }}>
            Modified by
          </TableHeaderColumn>
          <TableHeaderColumn dataField="placedDate" dataSort dataFormat={dateFormatter}>
            Last Modified
          </TableHeaderColumn>
          <TableHeaderColumn dataField="phoneLine" dataSort filter={{ type: "TextFilter", delay: 100 }}>
            Phone
          </TableHeaderColumn>
          <TableHeaderColumn dataField="ip" dataSort filter={{ type: "TextFilter", delay: 100 }}>
            IP
          </TableHeaderColumn>
        </BootstrapTable>
      </div>
    </div>
  </TabPanel>
</Paper>

          </div>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" onClick={() => handleOpenDialog(false)}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default Changes;
